import RoundedStatus from "../RoundedStatus/RoundedStatus";
import style from "./Milestone.module.css";
import { useState } from "react";
import User from "../../Services/User";
import { toast } from "react-toastify";
import { Error, Post } from "../../Services/Server";
import Url from "../../Services/Url";
import { ModalAction } from "../../Routes/NavRouter";

const Milestone = ({ children, onChange, updateUrl }) => {
	const { name, group } = children;
	const { executor, status } = group[0];
	const roles = User.getRoles();
	const role = User.getRole();

	const hasRole = (roleName) =>
		roles?.some((role) => role?.name.toLowerCase() === roleName.toLowerCase());

	const isExecutor = hasRole(executor.name.toLowerCase()) && status.id === 1;
	const isOperator = hasRole("operation") ;
	const isEnterpriseOperator = hasRole("enterprise-ops");
	const isEnterpriseExecutor =
		(hasRole("enterprise") || hasRole("enterprise-ops")) &&
		((executor.name.toLowerCase() === "engineer" && hasRole("enterprise")) ||
			(executor.name.toLowerCase() === "operation" &&
				hasRole("enterprise-ops"))) &&
		status.id === 1;

	const isAdmin = hasRole("admin") || hasRole("enterprise-admin");

	const send = (opList) => {
		opList
			.filter((op) => op.selected)
			.forEach((op) => {
				const currentStatus = op.status.id;

				// Decision logic: if admin and current status is 3 → revert to 1
				if (
					(isAdmin || isEnterpriseOperator || isOperator || isExecutor) &&
					currentStatus === 3
				) {
					op.status = { id: 1 };
				} else {
					op.status = {
						id: role.id === 1 && children.approvalRequired ? 2 : 3,
					};
				}

				Post(updateUrl, op)
					.then((resp) => {
						toast("Status updated");
						onChange(op);
					})
					.catch((err) => {
						Error(err);
					});
			});
	};

	const confirmOption = {
		title: name,
		text: "You are about to update the milestone status",
		options: group,
		exitText: "Exit",
		okText: "Continue",
		onOk: send,
	};

	const onClick = (state) => {
		if (!state) return;

		if (
			isOperator ||
			isEnterpriseOperator ||
			isExecutor ||
			isEnterpriseExecutor ||
			isAdmin
		) {
			ModalAction.confirm(confirmOption);
		} else if (status.id === 1) {
			toast("This operation is reserved for " + executor.name);
		} else {
			toast("This function is reserved for Operation");
		}
	};

	return (
		<div className={style.Milestone}>
			<div>
				<RoundedStatus onClick={onClick} status={status.id}></RoundedStatus>
			</div>
			<div className={style.Title}>
				{name}
				<span className={style.count}>{group.length}</span>
			</div>
		</div>
	);
};

export default Milestone;
